<template>
    <b-container class="m-0 p-0" > 

        <b-container v-for="(item, index) in tradePointContacts" :key="index" class="p-0 m-0">

            <b-row class="m-0 contacts-view-label">
                {{item.Position}}
            </b-row>       
            <b-row class="m-0 contacts-info">
                {{item.Fio}}
            </b-row>
            <b-row class="m-0 contacts-info">
                {{item.Phone}}
            </b-row>  
            <b-row v-if="item.Email" class="m-0">
                <span class="info-view-label"> Email: </span>
                <span class="info-item"> 
                    {{item.Email}} 
                </span>
            </b-row>
            <b-row v-if="item.Skype" class="m-0">
                <span class="info-view-label"> Skype: </span>
                <span class="info-item"> 
                    {{item.Skype}} 
                </span>
            </b-row>
            <b-row v-if="item.Birthday" class="m-0">
                <span class="info-view-label"> Дата рождения: </span>
                <span class="info-item"> 
                    {{item.getBirthdayToDisplay()}} 
                </span>
            </b-row>
            <b-row v-if="item.SocialNetworks" class="m-0">
                <span class="info-view-label"> Социальные сети: </span>
                <span class="info-item"> 
                    {{item.SocialNetworks}} 
                </span>
            </b-row>
            
            <hr v-if="index != tradePointContacts.length-1" class="my-4"/>

        </b-container>                          

    </b-container>
</template>

<script>

export default {
    props: {
        tradePointContacts: {
            type: Array,
            default: () => []
        }
    }
}
</script>